import { IVideoClip } from '../../../api/vault/clipList';
import { IExchangeSchedule } from '../../../api/vault/exchangeSchedule';
import { SelectOptionType } from '../../../utils/selection';

const getIndex = (
  selectedValue: string,
  options: Array<any>,
): number => {
  let foundIndex = 0;
  let found = false;
  for (let i = 0; i < options.length; i += 1) {
    const option = options[i];
    if (option?.options?.length > 0) {
      for (let j = 0; j < option.options.length; j += 1) {
        const subOption = option.options[j];
        if (subOption.value === selectedValue) {
          foundIndex = i * 10 + j;
          found = true;
          break;
        }
      }
      if (found) break;
    }
    if (option.value === selectedValue) {
      foundIndex = i * 10;
      break;
    }
  }
  return foundIndex;
};

export const orderClipsBasedOnQualifier = (
  clips: IVideoClip[],
  exchangeQualifierOptions: SelectOptionType<string>[],
): IVideoClip[] => {
  const orderedClips = [...clips];
  orderedClips.sort((a, b) => {
    const aIndex = getIndex(a.name, exchangeQualifierOptions);
    const bIndex = getIndex(b.name, exchangeQualifierOptions);
    return aIndex - bIndex;
  });
  return orderedClips;
};

export const buildExchangeTitle = (clip: IVideoClip, exchangeSchedule: IExchangeSchedule) => `${exchangeSchedule.NCAAGameNumber} ${exchangeSchedule.HomeTeamName} vs ${exchangeSchedule.VisitorTeamName} -  ${clip.name}`;
